module.exports = __webpack_public_path__ + "media/images/lb/773-24f3438ceca9ad4fe079baf1a12ce18a.svg";